import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Person, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MetadataIconsContainer from './MetadataIconsContainer'

type PersonIconProps = {
  message: string
}

const PersonIcon = ({ message }: PersonIconProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const color = sys[theme].text.placeholder
  const tooltip = `${t('followerDailyUniqueVisitor_other')}: ${message}`

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={message}>
          <Person color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default PersonIcon
